import isString from './is-string';

const parseStringBoolean = (string) => string === true || (isString(string) && string.toLowerCase() === 'true');

export default parseStringBoolean;
